export const DEFAULT_OUTCOME_PRECEDENCE_INDEX = 1;
export const PREVIEW_OUTCOME_ACTION_NAME = '';
